export default "__VITE_ASSET__CJxP0D_3__"